import React from 'react';
import { FileTextIcon, SearchIcon, CalculatorIcon, ClockIcon, ShieldIcon } from 'lucide-react';
import { AnimatedSection, AnimatedItem } from './AnimatedSection';
export function WhatYouGetSection() {
  return <section className="w-full bg-navy-800" data-id="element-303">
      <div className="max-w-5xl mx-auto px-5 sm:px-8 py-20 md:py-28" data-id="element-304">
        <AnimatedSection data-id="element-305">
          <AnimatedItem data-id="element-306">
            <div className="flex items-center gap-3 mb-4" data-id="element-307">
              <div className="h-px flex-1 max-w-[60px] bg-gold-500/40" data-id="element-308" />
              <span className="text-gold-400 text-xs font-body font-semibold tracking-[0.2em] uppercase" data-id="element-309">
                Lo Que Recibes
              </span>
            </div>
          </AnimatedItem>

          <AnimatedItem data-id="element-310">
            <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold text-white leading-tight" data-id="element-311">
              Todo lo que incluye tu{' '}
              <span className="text-gold-400" data-id="element-312">Plan Retiro</span>
            </h2>
          </AnimatedItem>

          <div className="mt-10 space-y-4" data-id="element-313">
            <AnimatedItem data-id="element-314">
              <div className="flex items-start gap-5 p-5 md:p-6 rounded-xl bg-navy-700/50 border border-slate-700/30" data-id="element-315">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center" data-id="element-316">
                  <FileTextIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-317" />
                </div>
                <div data-id="element-318">
                  <h3 className="font-display text-lg font-bold text-white mb-1" data-id="element-319">
                    La Hoja de Ruta completa del Plan Retiro
                  </h3>
                  <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-320">
                    Guía PDF paso a paso con todo el sistema explicado en
                    lenguaje sencillo.
                  </p>
                </div>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-321">
              <div className="flex items-start gap-5 p-5 md:p-6 rounded-xl bg-navy-700/50 border border-slate-700/30" data-id="element-322">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center" data-id="element-323">
                  <SearchIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-324" />
                </div>
                <div data-id="element-325">
                  <h3 className="font-display text-lg font-bold text-white mb-1" data-id="element-326">
                    El Protocolo de Selección Triple A
                  </h3>
                  <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-327">
                    Para identificar solo activos seguros y de alta calidad.
                  </p>
                </div>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-328">
              <div className="flex items-start gap-5 p-5 md:p-6 rounded-xl bg-navy-700/50 border border-slate-700/30" data-id="element-329">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center" data-id="element-330">
                  <CalculatorIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-331" />
                </div>
                <div data-id="element-332">
                  <h3 className="font-display text-lg font-bold text-white mb-1" data-id="element-333">
                    La Matriz de Generación de Primas
                  </h3>
                  <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-334">
                    Para calcular cuánto flujo de caja recibirás cada mes.
                  </p>
                </div>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-335">
              <div className="flex items-start gap-5 p-5 md:p-6 rounded-xl bg-navy-700/50 border border-slate-700/30" data-id="element-336">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center" data-id="element-337">
                  <ClockIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-338" />
                </div>
                <div data-id="element-339">
                  <h3 className="font-display text-lg font-bold text-white mb-1" data-id="element-340">
                    Lista de verificación: "Tu primera operación en 30 minutos"
                  </h3>
                  <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-341">
                    Checklist paso a paso para ejecutar tu primera venta de
                    primas hoy mismo.
                  </p>
                </div>
              </div>
            </AnimatedItem>

            <AnimatedItem data-id="element-342">
              <div className="flex items-start gap-5 p-5 md:p-6 rounded-xl bg-navy-700/50 border border-slate-700/30" data-id="element-343">
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-gradient-to-br from-gold-500/20 to-gold-600/10 flex items-center justify-center" data-id="element-344">
                  <ShieldIcon className="w-6 h-6 text-gold-400" aria-hidden="true" data-id="element-345" />
                </div>
                <div data-id="element-346">
                  <h3 className="font-display text-lg font-bold text-white mb-1" data-id="element-347">
                    Guía de gestión de riesgos
                  </h3>
                  <p className="text-slate-400 font-body text-sm leading-relaxed" data-id="element-348">
                    Para proteger tu capital en mercados bajistas y dormir
                    tranquilo.
                  </p>
                </div>
              </div>
            </AnimatedItem>
          </div>
        </AnimatedSection>
      </div>

      <div className="h-px bg-gradient-to-r from-transparent via-gold-500/20 to-transparent" data-id="element-349" />
    </section>;
}